module.exports = __webpack_public_path__ + "media/images/icon_movie2-cf7d84ddfe5f80229aa06483bd268b48.svg";